var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1297_1142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 1.00024C10.5 0.447959 10.0523 0.000244141 9.5 0.000244141C8.94772 0.000244141 8.5 0.447959 8.5 1.00024V4.50024H5.5C4.94772 4.50024 4.5 4.94796 4.5 5.50024V10.0002C4.5 13.0325 6.96772 15.5002 10 15.5002H11V22.7302C11 23.2825 11.4477 23.7302 12 23.7302C12.5523 23.7302 13 23.2825 13 22.7302V15.5002H14C17.0323 15.5002 19.5 13.0325 19.5 10.0002V5.50024C19.5 4.94796 19.0523 4.50024 18.5 4.50024H15.5V1.00024C15.5 0.447959 15.0523 0.000244141 14.5 0.000244141C13.9477 0.000244141 13.5 0.447959 13.5 1.00024V4.50024H10.5V1.00024ZM12 13.5002H14C15.9277 13.5002 17.5 11.928 17.5 10.0002V6.50024H6.5V10.0002C6.5 11.928 8.07228 13.5002 10 13.5002H12Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1297_1142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 23.73,
    fill: "white",
    transform: "translate(4.5 0.000244141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.ac8470c75963bce326d244b70153ea43.svg";
export { ForwardRef as ReactComponent };